module.exports = __webpack_public_path__ + "static/media/VIP_EVENT_active.178b704b.svg";